import React, { FC } from 'react';
import { AnalyticsAdAccount } from 'types/AdAccount';
import { Toggle } from '@kontentino/ui';

type Props = {
  adAccounts: AnalyticsAdAccount[];
  onChange: (adAccount: AnalyticsAdAccount) => void;
  isConnected: (adAccount: AnalyticsAdAccount) => boolean;
};

export const AdAccountsList: FC<Props> = ({
  adAccounts,
  onChange,
  isConnected,
}) => {
  return (
    <div className="tw-flex tw-flex-col">
      {adAccounts.map((adAccount) => (
        <div
          className="tw-flex tw-items-center tw-p-1"
          key={adAccount.facebookAdAccountId}
        >
          <Toggle
            className="tw-my-0 tw-ml-0 tw-mr-3"
            size="small"
            checked={isConnected(adAccount)}
            onChange={(e) => {
              e.preventDefault();
              onChange(adAccount);
            }}
          />
          {adAccount.name}
        </div>
      ))}
    </div>
  );
};

export default AdAccountsList;
